// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styled-MainTransitionGroup-module--cls1--3cpMU","cls2":"styled-MainTransitionGroup-module--cls2--24grJ styled-MainTransitionGroup-module--cls1--3cpMU"};